import React, { useState } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import BCMustRefer from "../../BCMustRefer.js";
import ClauseCard from "../../ClauseCard.js";
import clauseData from "../../../data/BritishColumbia/clauseData.js";
import clauseCardDesc from "../../../data/BritishColumbia/clauseCardDescription.js";
import importantNotes from "../../../data/BritishColumbia/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";

export default function PreConPurchase() {
  const [SellerRep, setSellerRep] = useState("No");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [ListingType, setListingType] = useState("Exclusive");
  const [BuyerRep, setBuyerRep] = useState("a Client");

  const [BuyerDocs, setBuyerDocs] = useState([
    "Disclosure of Representation in Trading Services",
    "Buyers Agency Exclusive Contract or Buyers Agency Acknowledgement (highly recommended)",
    "Privacy Notice and Consent Form",
    "Related FINTRAC Documents",
  ]);

  const [DealDocs, setDealDocs] = useState([
    "Builder's Contract of Purchase & Sale",
    "Addendums (if applicable)",
    "Disclosure Statement",
    "Buyers Advisement (highly recommended)",
    "Disclosure of Remuneration",
    "Title Search (if applicable)",
    "Copy of Deposit & Receipt",
    "Builder's Fee Agreement",
  ]);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const toggleDisclosure = (e) => {
    if (e.target.value === "No") {
      setIsDisclosure("No");
      setDealDocs(
        DealDocs.filter(
          (item) => item !== "Disclosure of Interest in Trade (BCFSA Form)"
        )
      );
    } else {
      setIsDisclosure("Yes");
      if (!DealDocs.includes("Disclosure of Interest in Trade (BCFSA Form)")) {
        setDealDocs([
          ...DealDocs,
          "Disclosure of Interest in Trade (BCFSA Form)",
        ]);
      }
    }
  };

  const setExclusive = (e) => {
    setListingType(e.target.value);
    let newDealDocs = [...DealDocs];
    if (SellerRep === "No") {
      if (!newDealDocs.includes("Builder's Fee Agreement")) {
        newDealDocs.push("Builder's Fee Agreement");
      }
    }
    if (SellerRep === "Yes") {
      newDealDocs = newDealDocs.filter(
        (item) => item !== "Builder's Fee Agreement"
      );
    }
    newDealDocs = newDealDocs.filter(
      (item) => item !== "Full REALTOR® SOLD MLS Printout"
    );
    setDealDocs(newDealDocs);
  };

  const setMLS = (e) => {
    setListingType(e.target.value);
    let newDealDocs = [...DealDocs];
    if (!newDealDocs.includes("Full REALTOR® SOLD MLS Printout")) {
      newDealDocs.push("Full REALTOR® SOLD MLS Printout");
    }
    newDealDocs = newDealDocs.filter(
      (item) => item !== "Builder's Fee Agreement"
    );
    setDealDocs(newDealDocs);
  };

  const handleSellerRep = (e) => {
    if (e.target.value === SellerRep) {
      return;
    }
    setSellerRep(e.target.value);
    if (e.target.value === "Yes") {
      setListingType("MLS");
      let newDealDocs = [...DealDocs];
      newDealDocs = newDealDocs.filter(
        (item) =>
          item !== "Builder's Fee Agreement" &&
          item !== "Disclosure of Remuneration" &&
          item !== "Buyers Advisement (highly recommended)"
      );
      if (newDealDocs.includes("Full REALTOR® SOLD MLS Printout") === true) {
        setDealDocs(newDealDocs);
      } else {
        newDealDocs.push("Full REALTOR® SOLD MLS Printout");
        setDealDocs(newDealDocs);
      }
    }
    if (e.target.value === "No") {
      setBuyerRep("a Client");
      let newDealDocs = [...DealDocs];
      // Insert "Disclosure of Remuneration" in the 4th slot (index 3)
      if (!newDealDocs.includes("Disclosure of Remuneration")) {
        newDealDocs.splice(3, 0, "Buyers Advisement (highly recommended)");
        newDealDocs.splice(4, 0, "Disclosure of Remuneration");
      }
      if (ListingType === "Exclusive") {
        if (!newDealDocs.includes("Builder's Fee Agreement")) {
          newDealDocs.push("Builder's Fee Agreement");
        }
      }
      setDealDocs(newDealDocs);
      setBuyerDocs([
        "Disclosure of Representation in Trading Services",
        "Buyers Agency Exclusive Contract or Buyers Agency Acknowledgement (highly recommended)",
        "Privacy Notice and Consent Form",
        "Related FINTRAC Documents",
      ]);
    }
  };

  const handleBuyerRep = (e) => {
    setBuyerRep(e.target.value);
    if (e.target.value === "a Client") {
      setBuyerDocs([
        "Disclosure of Representation in Trading Services",
        "Buyers Agency Exclusive Contract or Buyers Agency Acknowledgement (highly recommended)",
        "Privacy Notice and Consent Form",
        "Related FINTRAC Documents",
      ]);
    } else {
      setBuyerDocs([
        "Disclosure of Representation in Trading Services",
        "Disclosure of Risks to Unrepresented Parties",
        "Privacy Notice and Consent Form",
        "Related FINTRAC Documents",
      ]);
    }
  };

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <div className="pr-5 pt-3">
            Do you also represent the Seller in this transaction?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {SellerRep === "Yes" ? (
            <>
              <div className="pr-5 pt-5">Buyer's Representation?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="a Client"
                    value={BuyerRep}
                  >
                    <FormControlLabel
                      value="a Client"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="an Unrepresented Party"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Unrepresented Party"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}
          <div className="pr-5 pt-5">Type of Listing?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="MLS"
                value={ListingType}
              >
                <FormControlLabel
                  value="MLS"
                  control={<Radio size="small" onClick={setMLS} />}
                  label="MLS"
                />
                <FormControlLabel
                  value="Exclusive"
                  control={<Radio size="small" onClick={setExclusive} />}
                  label="Exclusive"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-5">
            {SellerRep === "No"
              ? `Are you or immediate family members purchasing this property?`
              : `Are you or any of your close relatives the Buyer or the Seller?`}
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={toggleDisclosure} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={toggleDisclosure} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>

      {SellerRep === "Yes" && BuyerRep === "a Client" ? (
        <BCMustRefer IsMLS={ListingType} />
      ) : (
        <>
          <ChecklistCard
            province={"BC"}
            CheckListData={BuyerDocs}
            CheckListData2={DealDocs}
            Header={"Pre-Construction Purchase:"}
            Header2={"Buyer is " + BuyerRep}
            Title1="Buyer Documents"
            Title2="Deal Documents"
          />
        </>
      )}

      {SellerRep === "Yes" &&
      BuyerRep === "a Client" &&
      IsDisclosure === "Yes" ? (
        ""
      ) : (
        <ClauseCard
          ClauseCardDescription={clauseCardDesc.filter((item) =>
            item.category.includes("precon")
          )}
          ClauseDataCommon={clauseData.filter(
            (item) =>
              item.category.includes("precon") && item.isCommon === "yes"
          )}
          ClauseDataSituational={clauseData.filter(
            (item) => item.category.includes("precon") && item.isCommon === "no"
          )}
          PurchaseType="PreCon"
        />
      )}

      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>

        {IsDisclosure === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosure") === true
            )}
          />
        ) : (
          ""
        )}

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("precon") === true
          )}
        />
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("purchase") === true
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}
